export default __webpack_public_path__ + "static/media/loader.9eeae8a0.svg";